import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { SITE } from "../config";

export const FAQ_ITEMS = [
  {
    q: "What exactly is included in the $800?",
    a: "Everything a small business website needs to win leads: up to 5 custom-designed pages, a mobile-first layout, a lead capture form, a Calendly booking embed, basic on-page SEO, SSL security, 1 full year of hosting, one consolidated feedback round on your first cut, and 30 days of free minor text and image tweaks after launch.",
  },
  {
    q: "What if I need more than 5 pages?",
    a: "No problem. Extra pages are quoted separately before any work starts, so you approve the exact price first. You will never see a surprise line item on an invoice from us.",
  },
  {
    q: "How fast is delivery, really?",
    a: "You see the first cut of your website within 48 hours of kickoff, and your final website goes live within 72 hours. The clock starts at kickoff, and it stays on track as long as your content and feedback reach us on time.",
  },
  {
    q: "How do revisions work?",
    a: "You get one consolidated feedback round on the first cut — collect all your comments, send them in one go, and we apply them for the final version. After launch, minor text and image tweaks are free for 30 days.",
  },
  {
    q: "What happens to hosting after the first year?",
    a: `Hosting renews at $${SITE.renewalPerYear} per year — that is it, and we tell you this upfront, not in the fine print. You can cancel anytime. Your content and domain stay yours either way.`,
  },
  {
    q: "Do I own my website and domain?",
    a: "Yes, completely. Your domain is registered in your name, your content is yours, and you can export your site files at any time. No lock-in, no hostage situations.",
  },
  {
    q: "Do I need to write my own content?",
    a: "No. Bring rough notes about your business — what you do, who you serve, what makes you different — and we shape them into clear, lead-focused copy for your pages. You approve every word before launch.",
  },
  {
    q: "How does payment work?",
    a: "Two ways. Split it: 50% to start the build and 50% before the final launch. Or pay in full upfront. Either way the price is the same flat $800 — no interest, no fees.",
  },
  {
    q: "What is your refund policy?",
    a: "Plain and simple: we do not offer refunds. We know that is a big ask, so we balance it with real risk reducers — a free, no-obligation demo before you pay anything, and your first cut in your hands within 48 hours, before the final payment is due. You will never pay the full price for something you have not seen.",
  },
  {
    q: "How do I get support?",
    a: "Email us through the contact page anytime. We usually reply within one business day, often within a few hours. For the first 30 days after launch, minor tweaks are on us.",
  },
];

export const FAQAccordion = ({ items = FAQ_ITEMS }) => (
  <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
    {items.map((item, i) => (
      <AccordionItem
        key={i}
        value={`faq-${i}`}
        className="border-white/[0.07]"
        data-testid={`faq-accordion-item-${i + 1}`}
      >
        <AccordionTrigger className="text-left font-display text-base font-semibold text-slate-100 hover:text-volt hover:no-underline sm:text-lg">
          {item.q}
        </AccordionTrigger>
        <AccordionContent className="text-sm leading-relaxed text-mist sm:text-base">
          {item.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
